import { render, staticRenderFns } from "./HistoryChatDetail.vue?vue&type=template&id=377c2788&scoped=true"
import script from "./HistoryChatDetail.vue?vue&type=script&lang=js"
export * from "./HistoryChatDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryChatDetail.vue?vue&type=style&index=0&id=377c2788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c2788",
  null
  
)

export default component.exports